import { Map, Record, fromJS } from 'immutable'
import { SUCCESS } from 'crom-api-constants'
import _ from 'lodash'

import { REPORT_GET_TOKEN_REQUEST, REPORT_ENTITY_UPDATE, REPORT_REMOVE } from '../../constants'

import { mergeDeepUpdates } from '../../../helpers'

import { EntityRecord } from '../../../../../../global/records'

export const ReportRecord = Record({
    id: '',
    token: '',
    entity: new EntityRecord(),
    blocks: Map(),
})

const entityIdRegex = '\\d+' // entity id must be only number (internally is string)

const tokenSuccessRegex = new RegExp(`^${REPORT_GET_TOKEN_REQUEST(entityIdRegex)}_${SUCCESS}$`)
const entityUpdateRegex = new RegExp(`^${REPORT_ENTITY_UPDATE(entityIdRegex)}$`)
const removeReportRegex = new RegExp(`^${REPORT_REMOVE}$`)

export default function workspaceReducer(state = Map(), action = {}) {
    switch (true) {
        // REPORT_GET_entityId_TOKEN_REQUEST_SUCCESS
        case tokenSuccessRegex.test(action.type): {
            const data = _.get(action, 'payload.response.body', null)
            const entityId = _.get(data, 'entity.id', null)
            if (!data || !entityId) return state

            return state.set(
                _.toString(entityId),
                new ReportRecord({
                    ...data,
                    id: _.toString(entityId),
                    entity: new EntityRecord(fromJS(_.get(data, 'entity', {}))),
                })
            )
        }
        // REPORT_ENTITY_UPDATE_entityId_REQUEST
        case entityUpdateRegex.test(action.type): {
            const entityId = _.get(action, 'data.entityId', null)
            if (!entityId) return state

            const updates = _.get(action, 'data.updates', Map())
            return state.set(_.toString(entityId), mergeDeepUpdates(state.get(_.toString(entityId)), updates))
        }
        // REPORT_REMOVE
        case removeReportRegex.test(action.type): {
            const entityId = _.get(action, 'data.entityId', null)
            if (!entityId) return state

            return state.delete(entityId)
        }
        default:
            return state
    }
}
